import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store';
import { retrieveRedirectUrl, clearRedirectUrl, getRedirectUrl, getIntentRedirectFromSearch } from '../../utils/redirectUrl';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, user } = useAppSelector(state => state.auth);

  // If user is authenticated and has user data, redirect appropriately
  if (isAuthenticated && user) {
    const intentRedirect = getIntentRedirectFromSearch(location.search, user.role);
    const storedUrl = retrieveRedirectUrl();
    const redirectUrl = intentRedirect || storedUrl || getRedirectUrl(location.state, user.role);
    clearRedirectUrl();
    
    return <Navigate to={redirectUrl} replace />;
  }

  // Otherwise, allow access to public routes (login/register)
  return <>{children}</>;
};

export default PublicRoute;
